import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import {
  getQuoteCustomerDataApi,
  getQuoteProGroupsAttributeApi,
  getCustomerPushCartApi,
  getQuoteProProductsApi
} from 'api';
import {
  Breadcrumb,
  BackdropCircular
} from 'components';
import QuoteItems from '../QuoteItems/QuoteItems';
import QuotePatientData from './QuotePatientData';


const QuotePatientPage = () => {
  const dispatch = useDispatch();
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';
  const { id } = useParams<{ id?: string }>();
  const {
    currentQuoteCustomer,
    quoteGroupsAttributeData,
    loadingQuoteCustomers,
    quoteProductsByGroup,
    quoteProducts,
    quoteGroupsLoading,
    customerPushCart,
    quoteProductsLoading,
    loadingQuoteProductSubscriptionOptions,
    loadingCustomerPushCart,
    loadingTouchmdActivity,
    allQuoteProducts
  } = useSelector((state: IReduxState) => state.quote);
  const { isChargesByCustomerLoading } = useSelector((state: IReduxState) => state.rpa);

  useEffect(() => {
    if (!currentQuoteCustomer) {
      getQuoteCustomerDataApi({ dispatch, id });
    }
  }, [currentQuoteCustomer, dispatch, id]);

  useEffect(() => {
    if (!customerPushCart && currentQuoteCustomer?.id) {
      getCustomerPushCartApi({
        dispatch,
        customerId: currentQuoteCustomer?.id
      });
    }
  }, [currentQuoteCustomer]);

  useEffect(() => {
    if (!quoteGroupsAttributeData.options.length) {
      getQuoteProGroupsAttributeApi({ dispatch });
    }

    if (!allQuoteProducts.length && !Object.keys(quoteProductsByGroup).length && !quoteProducts.length) {
      getQuoteProProductsApi({dispatch});
    }
  }, []);

  const loading =
    quoteProductsLoading ||
    loadingQuoteCustomers ||
    quoteGroupsLoading ||
    loadingCustomerPushCart ||
    loadingQuoteProductSubscriptionOptions ||
    loadingTouchmdActivity ||
    isChargesByCustomerLoading;

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Create Quote', path: '/quoting/' },
            { name: `${isCustomer3 ? 'Customer' : 'Patient'} Details` }
          ]}
        />
      </div>
      <Grid container spacing={2} className="px-8">
        <Grid item xs={12} md={6}>
          <QuoteItems />
        </Grid>
        <Grid item xs={12} md={6}>
          <QuotePatientData />
        </Grid>
      </Grid>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default QuotePatientPage;
